import {Capability} from 'auth/capabilities/CapabilityFeatureConstants';
import {isCapabilityEnabledForListing} from 'auth/capabilities/isCapabilityEnabledForListing';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';

export default function isModelTypeEnabledForListing(type: string): boolean {
  switch (type) {
    // Bioentities
    case ModelTypeConstants.ANTIBODY:
      return isCapabilityEnabledForListing(Capability.BIOLOGICS);
    case ModelTypeConstants.ANTIBODY_DRUG_CONJUGATE:
      return false; // TODO(BNCH-172813): Enable ADCs in listing
    case ModelTypeConstants.EQUIPMENT:
      return BenchlingConfig.ENABLE_EQUIPMENT;
    case ModelTypeConstants.OLIGO_CONJUGATE:
      return BenchlingConfig.MODBIO_ENABLE_COMPOSITE_ENTITIES;
    case ModelTypeConstants.OLIGO_DUPLEX:
      return BenchlingConfig.MODBIO_ENABLE_COMPOSITE_ENTITIES;
    case ModelTypeConstants.BASIC_FOLDER_ITEM:
      return isCapabilityEnabledForListing(Capability.REGISTRY);
    case ModelTypeConstants.SCHEMA_INTERFACE:
      return true;
    case ModelTypeConstants.PROTEIN:
    case ModelTypeConstants.PROTEIN_ALIGNMENT:
      return (
        isCapabilityEnabledForListing(Capability.MOLBIO) || isCapabilityEnabledForListing(Capability.REGISTRY)
      );
    case ModelTypeConstants.MIXTURE:
      return isCapabilityEnabledForListing(Capability.REGISTRY);
    case ModelTypeConstants.MOLECULE:
      return BenchlingConfig.CHEMISTRY_ENABLE_MOLECULE;
    case ModelTypeConstants.REACTION:
      return BenchlingConfig.CHEMISTRY_ENABLE_STOICHIOMETRY_TABLE;
    case ModelTypeConstants.SEQUENCE_ANALYSIS:
    case ModelTypeConstants.SEQUENCE:
    case ModelTypeConstants.RNA_SEQUENCE:
    case ModelTypeConstants.DNA_OLIGO:
      return (
        isCapabilityEnabledForListing(Capability.MOLBIO) || isCapabilityEnabledForListing(Capability.REGISTRY)
      );
    case ModelTypeConstants.RNA_OLIGO:
      return (
        isCapabilityEnabledForListing(Capability.MOLBIO) || isCapabilityEnabledForListing(Capability.REGISTRY)
      );
    // MolBio
    case ModelTypeConstants.BULK_ASSEMBLY:
      return isCapabilityEnabledForListing(Capability.MOLBIO);
    case ModelTypeConstants.CANVAS_FOLDER_ARTIFACT:
      return BenchlingConfig.ENABLE_CANVAS_SAVE_TO_FOLDER;
    // Inventory
    case ModelTypeConstants.BATCH:
      return false;
    case ModelTypeConstants.CONTAINER:
    case ModelTypeConstants.PLATE:
    case ModelTypeConstants.BOX:
    case ModelTypeConstants.LOCATION:
      return isCapabilityEnabledForListing(Capability.INVENTORY);
    case ModelTypeConstants.FIXED_PLATE:
    case ModelTypeConstants.MATRIX_PLATE:
      // Listing by plate types is not supported in the UI
      return false;
    // Processes
    case ModelTypeConstants.PROCESS:
    case ModelTypeConstants.PROCESS_OUTPUT:
    case ModelTypeConstants.PROCESS_TASK:
      return isCapabilityEnabledForListing(Capability.PROCESSES);
    // Recipes
    case ModelTypeConstants.RECIPE_PROCEDURE:
    case ModelTypeConstants.RECIPE_RUN_TASK:
    case ModelTypeConstants.RECIPE_UNIT_OPERATION_TASK:
    case ModelTypeConstants.RECIPE_STEP_TASK:
      return isCapabilityEnabledForListing(Capability.RECIPES);
    // Assays
    case ModelTypeConstants.ASSAY_PROCEDURE:
    case ModelTypeConstants.ASSAY_RUN_TASK:
    case ModelTypeConstants.ASSAY_UNIT_OPERATION_TASK:
    case ModelTypeConstants.ASSAY_STEP_TASK:
      return isCapabilityEnabledForListing(Capability.ASSAYS);
    case ModelTypeConstants.TEST_ORDER:
      return BenchlingConfig.SAMPLE_TESTS_ENABLE && isCapabilityEnabledForListing(Capability.ASSAYS);
    // ELN
    case ModelTypeConstants.PROTOCOL:
      return BenchlingConfig.ENABLE_PROTOCOLS;
    case ModelTypeConstants.ENTRY:
      return true;
    case ModelTypeConstants.STAGE_ENTRY:
    case ModelTypeConstants.WORKFLOW:
      return isCapabilityEnabledForListing(Capability.WORKFLOWS);
    // Requests
    case ModelTypeConstants.REQUEST:
      return isCapabilityEnabledForListing(Capability.REQUESTS);
    case ModelTypeConstants.REQUEST_V2_SUBMISSION:
      return isCapabilityEnabledForListing(Capability.V2_REQUESTS);
    case ModelTypeConstants.REQUEST_V2_DEFINITION:
      return isCapabilityEnabledForListing(Capability.V2_REQUESTS);
    case ModelTypeConstants.ASSAY_RUN:
      return isCapabilityEnabledForListing(Capability.LAB_AUTOMATION);
    // Insights
    case ModelTypeConstants.ANALYTICS_DASHBOARD:
      return isCapabilityEnabledForListing(Capability.INSIGHTS);
    // Analysis tool
    case ModelTypeConstants.ANALYSIS:
      return BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS;
    case ModelTypeConstants.ANALYSIS_TEMPLATE:
      return (
        BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS &&
        isCapabilityEnabledForListing(Capability.ADVANCED_ANALYSIS)
      );
    case ModelTypeConstants.CONNECTION:
      return isCapabilityEnabledForListing(Capability.LAB_AUTOMATION) && BenchlingConfig.INSTRUMENTS_ENABLE;
    // App Core
    case ModelTypeConstants.JELLYFISH:
      return BenchlingConfig.APP_CORE_ENABLE_FAKE_ITEM_TYPE;
    case ModelTypeConstants.STUDY:
      // TODO(BNCH-63553): Update with proper Capability Management
      return BenchlingConfig.STUDIES_ENABLE;
    case ModelTypeConstants.WORKSHEET:
    case ModelTypeConstants.RECIPE_PROCESS:
      return BenchlingConfig.PROCEDURES_ENABLE;
    case ModelTypeConstants.ASSAY_PROCESS:
      return BenchlingConfig.PROCEDURES_ENABLE_ASSAYS;
    // SDMS
    case ModelTypeConstants.DATASET:
      return BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS;
    // Plates
    case ModelTypeConstants.PLATE_DESIGN_TEMPLATE:
      return BenchlingConfig.ENABLE_SCRATCH_PLATES;
    default:
      return true;
  }
}
